export default __webpack_public_path__ + "static/media/vutre.0ff89642.jpg";